var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBurgerBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.68751 20C1.49226 20 1.32909 19.9312 1.19801 19.7936C1.06693 19.656 1.00093 19.4867 1.00001 19.2855C0.999093 19.0844 1.06509 18.9155 1.19801 18.7788C1.33093 18.6422 1.49409 18.5743 1.68751 18.5753H22.3125C22.5077 18.5753 22.6709 18.6436 22.802 18.7802C22.934 18.9169 23 19.0863 23 19.2884C23 19.4905 22.934 19.6594 22.802 19.795C22.67 19.9307 22.5068 19.9986 22.3125 19.9986L1.68751 20ZM1.68751 13.2109C1.49226 13.2109 1.32909 13.1426 1.19801 13.006C1.06693 12.8693 1.00093 12.7 1.00001 12.4979C0.999093 12.2958 1.06509 12.1269 1.19801 11.9912C1.33093 11.8555 1.49409 11.7876 1.68751 11.7876H22.3125C22.5077 11.7876 22.6709 11.856 22.802 11.9926C22.9331 12.1292 22.9991 12.2986 23 12.5007C23.0009 12.7028 22.9349 12.8717 22.802 13.0074C22.6691 13.1431 22.5059 13.2109 22.3125 13.2109H1.68751ZM1.68751 6.42186C1.49226 6.42186 1.32909 6.35402 1.19801 6.21833C1.06601 6.0817 1.00001 5.91233 1.00001 5.71022C1.00001 5.50811 1.06601 5.33922 1.19801 5.20353C1.33001 5.06784 1.49318 5 1.68751 5H22.3125C22.5077 5 22.6709 5.06832 22.802 5.20495C22.9331 5.34159 22.9991 5.51001 23 5.71022C23.0009 5.91043 22.9349 6.07932 22.802 6.21691C22.6691 6.35449 22.5059 6.42281 22.3125 6.42186H1.68751Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerBlack);
export default __webpack_public_path__ + "static/media/burgerBlack.3ac56c980e75947d3cc0bf3dbfa90001.svg";
export { ForwardRef as ReactComponent };